import React, { useState, useEffect } from "react";
import Star from "./vectors/Star";
import "./Themes.scss";
import VectorCity from "./vectors/VectorCity";
import VectorFireworks from "./vectors/VectorFireworks";

const MAX_STARS = 50;

interface StarConfig {
    id: number;
    left: number;
    top: number;
    delay: number;
}

const ThemeNewyear = ({ children }: { children?: React.ReactNode }) => {
    const [stars, setStars] = useState<StarConfig[]>([]);

    useEffect(() => {
        // Create initial stars
        const initialStars: StarConfig[] = [];
        for (let i = 0; i < MAX_STARS; i++) {
            initialStars.push({
                id: Date.now() + Math.random() + i,
                left: Math.random() * 100,
                top: Math.random() * 100,
                delay: Math.random() * 2,
            });
        }
        setStars(initialStars);
    }, []);

    return (
        <div className="is-theme-newyear">
            {children}
            <div className="nav-body-vectors">
                {/* Stars */}
                {stars.map((star) => (
                    <Star
                        key={star.id}
                        left={star.left}
                        top={star.top}
                        delay={star.delay}
                    />
                ))}

                {/* Fireworks */}
                {[...Array(2)].map((_, i) => (
                    <FireworkItem key={i} />
                ))}

                {/* City silhouette (replacing mountains) */}
                <VectorCity className="vector-city" />

                {/* Fireworks */}
                {[...Array(3)].map((_, i) => (
                    <FireworkItem key={i} />
                ))}
            </div>
        </div>
    );
};

interface FireworkConfig {
    style: React.CSSProperties;
    color: string;
}

const FireworkItem = () => {
    const [key, setKey] = useState(0);

    // Generate config
    const generateConfig = (): FireworkConfig => {
        const scale = 0.5 + Math.random() * 1.2; // 0.5 - 1.2
        const duration = 1 + Math.random() * 3; // Slower: 1-3s

        return {
            style: {
                left: `${Math.random() * 90 + 0}%`,
                top: `${Math.random() * 39 + 1}%`,
                width: `${scale * 39}px`,
                height: `${scale * 39}px`,
                animation: `firework-burst ${duration}s ease-out forwards`,
                animationDelay: `${Math.random() * 2}s`
            },
            color: ["#f76c6cff", "#fbc82e", "#6aa0fdff", "#42f19dff", "#e96affff"][Math.floor(Math.random() * 5)]!
        };
    };

    const [config, setConfig] = useState<FireworkConfig>(() => generateConfig());

    const handleAnimationEnd = () => {
        // When animation ends (fades out), generate new config and remount
        setConfig(generateConfig());
        setKey(prev => prev + 1);
    };

    return (
        <VectorFireworks
            key={key}
            className="vector-fireworks"
            style={config.style}
            color={config.color}
            onAnimationEnd={handleAnimationEnd}
        />
    );
};

export default ThemeNewyear;

